import { render, staticRenderFns } from "./RedirectItemDetails.vue?vue&type=template&id=747b805c"
import script from "./RedirectItemDetails.vue?vue&type=script&lang=js"
export * from "./RedirectItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports